import { render, staticRenderFns } from "./RenderLevelDialog.vue?vue&type=template&id=0ff2b368&scoped=true"
import script from "./RenderLevelDialog.vue?vue&type=script&lang=js"
export * from "./RenderLevelDialog.vue?vue&type=script&lang=js"
import style0 from "./RenderLevelDialog.vue?vue&type=style&index=0&id=0ff2b368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff2b368",
  null
  
)

export default component.exports